"use client";

import { useRouter } from "next/navigation";
import { useLanguage } from "../../context/LanguageContext";
import { getSectionRoute } from "../../lib/navigationRoutes";
import { Header } from "../Header";
import SiteFooter from "../SiteFooter";
import DecisionSupportSection from "../sections/DecisionSupportSection";

export default function DecisionsPage(): JSX.Element {
  const { t, locale } = useLanguage();
  const router = useRouter();

  return (
    <div className="flex min-h-screen flex-col" dir={t.common.dir} lang={t.common.lang}>
      <Header />
      <main className="flex-1">
        <DecisionSupportSection
          headingLevel="h1"
          onNavigate={(section) => router.push(getSectionRoute(locale, section))}
        />
      </main>
      <SiteFooter />
    </div>
  );
}

